import { render } from "./ReservationDriverFields.vue?vue&type=template&id=b38443be"
import script from "./ReservationDriverFields.vue?vue&type=script&lang=js"
export * from "./ReservationDriverFields.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__